import React from "react";
import {
  TextField as MuiTextField,
  styled,
  TextFieldProps,
  Stack,
  Typography,
} from "@mui/material";

export default styled((props: TextFieldProps) => {
  const { label, ...textFieldProps } = props;
  return (
    <Stack spacing={0.5} width="100%">
      {label ? <Typography>{label}</Typography> : null}
      <MuiTextField
        {...textFieldProps}
        InputLabelProps={{
          color: "secondary",
          disableAnimation: true,
          shrink: true,
        }}
      />
    </Stack>
  );
})({
  fontWeight: 400,
  fontSize: 14,
  border: 0,
  padding: 0,
  "& .MuiInput-input": {
    padding: 10,
  },
  "& .MuiInputBase-root": {
    height: "100%",
    borderRadius: "15px",
  },
  "& .MuiSelect-select": {
    padding: `17px 14px`,
    "&:focus": {
      background: "none",
    },
  },
});
